module.exports = __webpack_public_path__ + "static/SCHIN-3467217266c5402184f555b578834268.png";